<template>
  <b-table
    :loading="isLoading"
    :paginated="paginated"
    :per-page="perPage"
    :striped="isStriped"
    :hoverable="hoverable"
    default-sort="name"
    :data="results"
    slot="content"
  >
    <template slot-scope="props">
      <b-table-column label="Jinete" field="rider" sortable>
        <link-to-detail type="rider" :resource-id="props.row.rider_id"> {{`${props.row.rider_presentation}`}} </link-to-detail>
      </b-table-column>
      <b-table-column label="Inicio Asignación" field="startDate">{{ moment(props.row.start_date, 'YYYY-MM-DD') | moment('LL')}}</b-table-column>
      <b-table-column label="Término Asignación" field="finishDate" v-if="props.row.end_date != null">
        {{ moment(props.row.end_date, 'YYYY-MM-DD') | moment('LL') }}
      </b-table-column>
      <b-table-column label="Término Asignación" field="finishDate" v-else>
        <p>En curso</p>
      </b-table-column>
    </template>

    <section class="section" slot="empty">
      <div class="content has-text-grey has-text-centered">
        <template v-if="isLoading">
          <p>
            <b-icon icon="dots-horizontal" size="is-large" />
          </p>
          <p>Cargando Resultados...</p>
        </template>
        <template v-else>
          <p>
            <b-icon icon="horseshoe" size="is-large" />
          </p>
          <p>No hay Resultados&hellip;</p>
        </template>
      </div>
    </section>
  </b-table>
</template>

<script>
import TenantService from '@/services/TenantService'
import LinkToDetail from '@/components/LinkToDetail'

export default {
  components: {
    LinkToDetail
  },
  props: {
    horseId: {
      required: true
    }
  },
  created () {
    this.getHistory()
  },
  data () {
    return {
      results: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      hoverable: true,
      isLoading: false,
      numberResult: 0
    }
  },
  methods: {
    async getHistory () {
      this.isLoading = true
      let params = {
        'include[0]': 'rider',
        'horse_id': this.horseId
      }
      let response = await TenantService.getHistoryAssignments(params)
      this.results = response.data.data
      this.numberResult = this.results.length
      this.isLoading = false
    }
  },
  watch: {
    horseId (value) {
      this.getHistory()
    },
    numberResult (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>
